import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseObject } from './base-object-model';

@JsonObject('Category')
export class Category extends BaseObject {
  @JsonProperty('id', Number, false) id: number = undefined;
  @JsonProperty('name', String, false) name: string = undefined;
}
